import { useState, useEffect } from 'react';

function useResponsive() {
    // Set initial state based on the window if available
    const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 768 : false);

    useEffect(() => {
        function handleResize() {
            setIsMobile((window.innerWidth <= 1000 || window.innerHeight >= window.innerWidth));
        }

        window.addEventListener('resize', handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
}
export default useResponsive;
